import { useEffect, useState } from "react";

import { useLocation } from "react-router-dom";
import styled from "styled-components";

import { Order } from "@sso/types";
import { Typography } from "@sso/ui/Typography";

import ItemTotals from "./ItemTotals";
import LineItems from "./LineItems";
import StripePayment from "./stripePayment";
import UserPaymentDetails from "./UserPaymentDetails";

const OuterGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  width: 100%;
  height: 100%;
  grid-template-areas: "orderSummary stripeForm";
  gap: 20px;
`;

const OrderSummary = styled.div`
  grid-area: orderSummary;
  border-right: 1px solid #ccc;
  padding-right: 0.5rem;
`;

const StripeForm = styled.div`
  grid-area: stripeForm;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ErrorContainer = styled.h4`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60%;
`;

const Payment = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const orderId = queryParams.get("orderId");
  const token = queryParams.get("token");
  const clientId = queryParams.get("clientId");

  const [order, setOrder] = useState<Order>();

  useEffect(() => {
    if (clientId && token && orderId) {
      sessionStorage.setItem("payment-token", token);
      const headers: HeadersInit = {
        "Content-Type": "application/json",
        "X-ClientId": clientId || "",
        "X-Security-Token": token,
      };

      fetch(`${process.env.REACT_APP_BASE_URL}/sso/Order/${orderId}`, {
        method: "GET",
        headers: headers,
      })
        .then(res => res.json())
        .then((data: any) => {
          setOrder(data.result);
        });
    }
  }, [token, clientId, orderId]);

  const render = () => {
    if (!clientId || !orderId || !token) {
      return (
        <ErrorContainer>We need an order ID, a client ID and a token to create a checkout session.</ErrorContainer>
      );
    } else {
      return (
        <OuterGrid>
          {order && (
            <>
              <OrderSummary>
                <UserPaymentDetails order={order} />
                <Typography size="1.2rem">Items Ordered</Typography>
                <LineItems items={order.lineItems} currency={order.transactionCurrency} />
                <ItemTotals order={order} />
              </OrderSummary>
              <StripeForm>
                <StripePayment clientId={clientId} token={token} order={order} />
              </StripeForm>
            </>
          )}
        </OuterGrid>
      );
    }
  };

  return render();
};

export default Payment;
